module.exports = __webpack_public_path__ + "static/media/dottedpattern.1a242eaa.png";